import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/58_card_back_chinese_lantern/58_card_back_chinese_lantern"
 * Contains 1 texture(s)
 */
export class CardsBacks58CardBackChineseLanternAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/58_card_back_chinese_lantern/58_card_back_chinese_lantern';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '58_chinese_lantern.png'
    ] as const;
}
